import { render, staticRenderFns } from "./cooperationControlSalesGoodsItem.vue?vue&type=template&id=1950cc54&scoped=true"
import script from "./cooperationControlSalesGoodsItem.vue?vue&type=script&lang=js"
export * from "./cooperationControlSalesGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./cooperationControlSalesGoodsItem.vue?vue&type=style&index=0&id=1950cc54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950cc54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1950cc54')) {
      api.createRecord('1950cc54', component.options)
    } else {
      api.reload('1950cc54', component.options)
    }
    module.hot.accept("./cooperationControlSalesGoodsItem.vue?vue&type=template&id=1950cc54&scoped=true", function () {
      api.rerender('1950cc54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/product/components/cooperationControlSalesGoodsItem.vue"
export default component.exports